// Generated by purs version 0.15.0
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Eq_Generic from "../Data.Eq.Generic/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_HeytingAlgebra from "../Data.HeytingAlgebra/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Restaumatic_Cart_Cart from "../Restaumatic.Cart.Cart/index.js";
import * as Restaumatic_Cart_ProductItem from "../Restaumatic.Cart.ProductItem/index.js";
import * as Restaumatic_Cart_PromotionalItem from "../Restaumatic.Cart.PromotionalItem/index.js";
import * as Restaumatic_Cart_State_PromotionalItem from "../Restaumatic.Cart.State.PromotionalItem/index.js";
import * as Restaumatic_Cart_State_StoredProductKey from "../Restaumatic.Cart.State.StoredProductKey/index.js";
import * as Restaumatic_Menu_Query from "../Restaumatic.Menu.Query/index.js";
import * as Restaumatic_Menu_V2_Env from "../Restaumatic.Menu.V2.Env/index.js";
import * as Restaumatic_Orders_Checkout_Types_ExtraDiscount from "../Restaumatic.Orders.Checkout.Types.ExtraDiscount/index.js";
import * as Restaumatic_PromotionsEngine_Cart_CartParams from "../Restaumatic.PromotionsEngine.Cart.CartParams/index.js";
import * as Restaumatic_Restaurant_Types_Id from "../Restaumatic.Restaurant.Types.Id/index.js";
var StoredProductItem = function (x) {
    return x;
};
var State = function (x) {
    return x;
};
var store = function (restaurantId) {
    return function (cart) {
        var toStoredItem = function (item) {
            return {
                key: Restaumatic_Cart_State_StoredProductKey.toStoredProductKey(Restaumatic_Cart_ProductItem.productItemKey(item)),
                quantity: Restaumatic_Cart_ProductItem.productItemQuantity(item),
                note: Restaumatic_Cart_ProductItem.productItemNote(item)
            };
        };
        return {
            restaurantId: restaurantId,
            items: Data_Functor.map(Data_Functor.functorArray)(toStoredItem)(Restaumatic_Cart_Cart.productItems(cart)),
            promotionalItems: Restaumatic_Cart_State_PromotionalItem.storePromotionalItems(Data_Functor.map(Data_Functor.functorArray)(Restaumatic_Cart_PromotionalItem.promotionalItemEngineItem)(Restaumatic_Cart_Cart.promotionalItems(cart))),
            couponCode: Restaumatic_Cart_Cart.couponCode(cart),
            extraDiscount: Restaumatic_Cart_Cart.extraDiscount(cart)
        };
    };
};
var restoreItem = function (menu) {
    return function (env) {
        return function (v) {
            return Data_Either.hush(Restaumatic_Menu_Query.runMenuQuery(menu)(Restaumatic_Cart_Cart.makeProductItem(env)({
                key: Restaumatic_Cart_State_StoredProductKey.fromStoredProductKey(v.key),
                note: v.note
            })(v.quantity)));
        };
    };
};
var restoreWithAssignmentMode = function (assignmentMode) {
    return function (menu) {
        return function (menuEnv) {
            return function (v) {
                var mFulfillmentMethod = Restaumatic_Menu_V2_Env.fulfillmentMethod(menuEnv);
                var assignPromotions$prime = function (v1) {
                    return function (items) {
                        return Data_Maybe.fromMaybe(items)(Restaumatic_Cart_State_PromotionalItem.restorePromotionalItemAssignments(v.promotionalItems)(items));
                    };
                };
                return Restaumatic_Cart_Cart.setExtraDiscount(v.extraDiscount)(Restaumatic_Cart_Cart.fromProductItems(mFulfillmentMethod)(assignmentMode)(menu)(assignPromotions$prime)(Data_Array.mapMaybe(restoreItem(menu)(menuEnv))(v.items))(v.couponCode));
            };
        };
    };
};
var restoreManualAssign = /* #__PURE__ */ (function () {
    return restoreWithAssignmentMode(Restaumatic_PromotionsEngine_Cart_CartParams.ManualAssign.value);
})();
var restore = /* #__PURE__ */ (function () {
    return restoreWithAssignmentMode(Restaumatic_PromotionsEngine_Cart_CartParams.AutoAssign.value);
})();
var readCouponCode = function (v) {
    return v.couponCode;
};
var newtypeStoredProductItem = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeState = {
    Coercible0: function () {
        return undefined;
    }
};
var isEmpty = function (v) {
    return Data_Maybe.isNothing(v.couponCode) && (Data_Foldable["null"](Data_Foldable.foldableArray)(v.items) || Data_Foldable.all(Data_Foldable.foldableArray)(Data_HeytingAlgebra.heytingAlgebraBoolean)((function () {
        var $30 = Data_Newtype.unwrap();
        return function ($31) {
            return (function (v1) {
                return v1 === 0;
            })((function (v1) {
                return v1.quantity;
            })($30($31)));
        };
    })())(v.items));
};
var genericStoredProductItem = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showStoredProductItem = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericStoredProductItem)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "key";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "note";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "quantity";
        }
    })(Data_Show.showRecordFieldsNil)(Data_Show.showInt))(/* #__PURE__ */ Data_Maybe.showMaybe(Data_Show.showString)))(Restaumatic_Cart_State_StoredProductKey.showStoredProductKey))))({
        reflectSymbol: function () {
            return "StoredProductItem";
        }
    }))
};
var genericState = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showState = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericState)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "couponCode";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "extraDiscount";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "items";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "promotionalItems";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "restaurantId";
        }
    })(Data_Show.showRecordFieldsNil)(Restaumatic_Restaurant_Types_Id.showRestaurantId))(/* #__PURE__ */ Data_Show.showArray(Restaumatic_Cart_State_PromotionalItem.showStoredPromotionalItem)))(/* #__PURE__ */ Data_Show.showArray(showStoredProductItem)))(/* #__PURE__ */ Data_Maybe.showMaybe(Restaumatic_Orders_Checkout_Types_ExtraDiscount.showExtraDiscount)))(/* #__PURE__ */ Data_Maybe.showMaybe(Data_Show.showString)))))({
        reflectSymbol: function () {
            return "State";
        }
    }))
};
var eqStoredProductItem = {
    eq: /* #__PURE__ */ Data_Eq_Generic.genericEq(genericStoredProductItem)(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(/* #__PURE__ */ Data_Eq_Generic.genericEqArgument(/* #__PURE__ */ Data_Eq.eqRec()(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(Data_Eq.eqRowNil)()({
        reflectSymbol: function () {
            return "quantity";
        }
    })(Data_Eq.eqInt))()({
        reflectSymbol: function () {
            return "note";
        }
    })(/* #__PURE__ */ Data_Maybe.eqMaybe(Data_Eq.eqString)))()({
        reflectSymbol: function () {
            return "key";
        }
    })(Restaumatic_Cart_State_StoredProductKey.eqStoredProductKey)))))
};
var eqState = {
    eq: /* #__PURE__ */ Data_Eq_Generic.genericEq(genericState)(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(/* #__PURE__ */ Data_Eq_Generic.genericEqArgument(/* #__PURE__ */ Data_Eq.eqRec()(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(Data_Eq.eqRowNil)()({
        reflectSymbol: function () {
            return "restaurantId";
        }
    })(Restaumatic_Restaurant_Types_Id.eqRestaurantId))()({
        reflectSymbol: function () {
            return "promotionalItems";
        }
    })(/* #__PURE__ */ Data_Eq.eqArray(Restaumatic_Cart_State_PromotionalItem.eqStoredPromotionalItem)))()({
        reflectSymbol: function () {
            return "items";
        }
    })(/* #__PURE__ */ Data_Eq.eqArray(eqStoredProductItem)))()({
        reflectSymbol: function () {
            return "extraDiscount";
        }
    })(/* #__PURE__ */ Data_Maybe.eqMaybe(Restaumatic_Orders_Checkout_Types_ExtraDiscount.eqExtraDiscount)))()({
        reflectSymbol: function () {
            return "couponCode";
        }
    })(/* #__PURE__ */ Data_Maybe.eqMaybe(Data_Eq.eqString))))))
};
var encodeStoredProductItem = /* #__PURE__ */ Foreign_Generic_Class.recordEncode()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
    reflectSymbol: function () {
        return "quantity";
    }
})(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.intEncode)))({
    reflectSymbol: function () {
        return "note";
    }
})(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Foreign_Generic_Class.stringEncode))))({
    reflectSymbol: function () {
        return "key";
    }
})(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Cart_State_StoredProductKey.encodeStoredProductKey)));
var encodeState = /* #__PURE__ */ Foreign_Generic_Class.recordEncode()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
    reflectSymbol: function () {
        return "restaurantId";
    }
})(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Restaurant_Types_Id.encodeRestaurantId)))({
    reflectSymbol: function () {
        return "promotionalItems";
    }
})(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayEncode(Restaumatic_Cart_State_PromotionalItem.encodeStoredPromotionalItem))))({
    reflectSymbol: function () {
        return "items";
    }
})(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayEncode(encodeStoredProductItem))))({
    reflectSymbol: function () {
        return "extraDiscount";
    }
})(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Restaumatic_Orders_Checkout_Types_ExtraDiscount.encodeExtraDiscount))))({
    reflectSymbol: function () {
        return "couponCode";
    }
})(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Foreign_Generic_Class.stringEncode))));
var decodeStoredProductItem = /* #__PURE__ */ Foreign_Generic_Class.recordDecode()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
    reflectSymbol: function () {
        return "quantity";
    }
})(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.intDecode))())({
    reflectSymbol: function () {
        return "note";
    }
})(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(Foreign_Generic_Class.stringDecode)))())({
    reflectSymbol: function () {
        return "key";
    }
})(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Cart_State_StoredProductKey.decodeStoredProductKey))());
var decodeState = /* #__PURE__ */ Foreign_Generic_Class.recordDecode()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
    reflectSymbol: function () {
        return "restaurantId";
    }
})(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Restaurant_Types_Id.decodeRestaurantId))())({
    reflectSymbol: function () {
        return "promotionalItems";
    }
})(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayDecode(Restaumatic_Cart_State_PromotionalItem.decodeStoredPromotionalItem)))())({
    reflectSymbol: function () {
        return "items";
    }
})(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayDecode(decodeStoredProductItem)))())({
    reflectSymbol: function () {
        return "extraDiscount";
    }
})(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(Restaumatic_Orders_Checkout_Types_ExtraDiscount.decodeExtraDiscount)))())({
    reflectSymbol: function () {
        return "couponCode";
    }
})(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(Foreign_Generic_Class.stringDecode)))());
export {
    State,
    store,
    restore,
    restoreManualAssign,
    restoreWithAssignmentMode,
    StoredProductItem,
    readCouponCode,
    isEmpty,
    decodeState,
    encodeState,
    genericState,
    newtypeState,
    showState,
    eqState,
    newtypeStoredProductItem,
    decodeStoredProductItem,
    encodeStoredProductItem,
    genericStoredProductItem,
    showStoredProductItem,
    eqStoredProductItem
};
export {
    CustomPizza,
    StandardPizza,
    CustomProduct,
    Dish,
    Drink,
    MenuCombo,
    MenuProduct,
    Pizza,
    SplitPizza,
    fromStoredProductKey,
    toStoredProductKey
} from "../Restaumatic.Cart.State.StoredProductKey/index.js";
//# sourceMappingURL=index.js.map
